// extracted by mini-css-extract-plugin
export default {"iconCheck":"styles-scoped__iconCheck--zZ68c","iconInfo":"styles-scoped__iconInfo--U6565"};